export default __webpack_public_path__ + "static/media/arrowdown.d4e90cfd.svg";